export class ListSaasEntitiesSort {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "SaasEntitySortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListSaasEntitiesSort.attributeTypeMap;
    }
    constructor() {
    }
}
